import { FC } from "react";
import { NetworkPortfolioManagementMembership } from "@app/network-portfolio-management/interfaces";
import { formatPercent, formatScore } from "@app/network-portfolio-management/utils/formatUtils";

interface AccuracyInsightsProps {
  membership: NetworkPortfolioManagementMembership | null;
  projectId: number;
}

export const AccuracyInsights: FC<AccuracyInsightsProps> = ({ membership, projectId }) => (
  <section
    className="network-portfolio-management-project-card__accuracy-insights"
    data-testid={`network-portfolio-management-card-accuracy-insights-${projectId}`}
    aria-labelledby={`accuracy-insights-section-label-${projectId}`}
  >
    <span id={`accuracy-insights-section-label-${projectId}`} className="network-portfolio-management-project-card__accuracy-insights-label">
      Accuracy Insights
    </span>
    <div className="network-portfolio-management-project-card__accuracy-insights-row">
      <div className="network-portfolio-management-project-card__accuracy-insights-cell">
        <span className="network-portfolio-management-project-card__accuracy-insights-stat-label">Index Score</span>
        <span className="network-portfolio-management-project-card__accuracy-insights-value">{formatScore(membership?.accuracyIndexScore)}</span>
      </div>
      <div className="network-portfolio-management-project-card__accuracy-insights-cell">
        <span className="network-portfolio-management-project-card__accuracy-insights-stat-label">Attestation Rate</span>
        <span className="network-portfolio-management-project-card__accuracy-insights-value">{formatPercent(membership?.accuracyAttestationRate)}</span>
      </div>
    </div>
  </section>
);
